import { CALL_API } from "redux-api-middleware";
import responseHandler from "responseHandler";
import {
    REQUEST_GET_ROLERIGHTS, SUCCESS_GET_ROLERIGHTS, ERROR_GET_ROLERIGHTS,
    REQUEST_EDIT_ROLERIGHTS, SUCCESS_EDIT_ROLERIGHTS, ERROR_EDIT_ROLERIGHTS
} from "typeConstants";
import api from "apis/user";

export function getRoleRights() {
    return function (dispatch) {
      dispatch({
        [CALL_API]: {
          endpoint: api.rolerights(),
          method: "GET",
          types: [
            //Request
            {
                type: REQUEST_GET_ROLERIGHTS,
            },
            //Recieve
            {
                type: SUCCESS_GET_ROLERIGHTS,
                payload: (action, state, res) =>
                res.json()
                    .then(data => {
                        return data;
                    })
            },
            //Error
            {
                type: ERROR_GET_ROLERIGHTS,
                payload: (action, state, res) => {
                    responseHandler.error(res, dispatch);
                }
            }
          ]
        }
      }
      );
    };
  }

  export function addRoleRights(roleIdRightIdPairs, lValue) {
    let roleRightsEditDto = {
        roleIdRightIdPairs: roleIdRightIdPairs,
        lValue: lValue
    };
    return function (dispatch) {
      dispatch({
        [CALL_API]: {
          endpoint: api.rolerights(),
          body: JSON.stringify(roleRightsEditDto),
          method: "POST",
          types: [
            //Request
            {
                type: REQUEST_EDIT_ROLERIGHTS,
            },
            //Recieve
            {
                type: SUCCESS_EDIT_ROLERIGHTS,
                payload: responseHandler.success("Success", dispatch)
            },
            //Error
            {
                type: ERROR_EDIT_ROLERIGHTS,
                payload: (action, state, res) => {
                    responseHandler.error(res, dispatch);
                }
            }
          ]
        }
      }
      );
    };
  }

  export function deleteRoleRights(roleIdRightIdPairs, lValue) {
    let roleRightsEditDto = {
        roleIdRightIdPairs: roleIdRightIdPairs,
        lValue: lValue
    };
    return function (dispatch) {
      dispatch({
        [CALL_API]: {
          endpoint: api.rolerights(),
          body: JSON.stringify(roleRightsEditDto),
          method: "DELETE",
          types: [
            //Request
            {
                type: REQUEST_EDIT_ROLERIGHTS,
            },
            //Recieve
            {
                type: SUCCESS_EDIT_ROLERIGHTS,
                payload: responseHandler.success("Success", dispatch)
            },
            //Error
            {
                type: ERROR_EDIT_ROLERIGHTS,
                payload: (action, state, res) => {
                    responseHandler.error(res, dispatch);
                }
            }
          ]
        }
      }
      );
    };
  }